<template>
  <div>
    <index-header></index-header>
    <div class="_wrapper">
      <div class="_img_box">
        <a :href="signupInfo.manual" target="_blank" v-if="signupInfo.manual">
          <a-icon type="file-text" />
          下载操作文档
        </a>
        <img :src="signupInfo.instructions" alt="帮助文档" v-if="signupInfo.instructions" />

      </div>
    </div>
  </div>
</template>

<script>
  import IndexCommon from './mixins/index_common';
  import IndexHeader from './components/IndexHeader';
  import config from '../../../config';

  export default {
    mixins: [IndexCommon],
    components: { IndexHeader },
    data() {
      return {
        config:config,

        signupInfo:{}
      };
    },
    async created() {
      let signup = {};
      {
        let { error, data } = await this.$ajax.gateway('/bm-teacher/ISignupNoticeApi_newNoticeProtocol', {
          METHOD: 'get',
          areaId: this.areaId,
          studentType: this.studentType
        });
        console.log('报名id',error,data);
        if(error || data.code!==200 || !data.data) return;
        signup = data.data;
      }

      // 根据报名通知查询报名须知内容 #李茹钰/2019-03-13#
      let {error, data } = await this.$ajax.gateway('/bm-teacher/ISignupProtocolApi_infoFree', {
        signupNoticeId: signup.signupNoticeId
      });
      console.log('报名须知',data);
      if(error || data.code!==200 || !data.data) return;
      this.signupInfo = data.data;
    },
    methods: {}
  };
</script>

<style lang="stylus" scoped>
  ._img_box {
    width 800px
    margin 0 auto 150px
    padding 30px 0 0
    a {
      color #079c9c
      display inline-block
      padding 0 0 20px
      font-size 16px
      &:hover {
        text-decoration underline
      }
    }
    img {
      display block
      width 100%
    }
  }
</style>
